import { useKitData } from "@/data/use-kits-data";
import { useGroupSlug } from "@/hooks/use-group-slug";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";
import { KitMenuTemplateMode } from "../KitMenuTemplate";
import { CollectionMenu } from "./CollectionMenu";
import { ConversationMenu } from "./ConversationMenu";
import { ExpertCreatorMenu } from "./ExpertCreatorMenu";
import { InterviewMenu } from "./InterviewMenu";
import { ProjectMenu } from "./ProjectMenu";
import { ProjectPresetMenu } from "./ProjectPresetMenu";
import { RepositoryMenu } from "./RepositoryMenu";
import { SkillCreatorMenu } from "./SkillCreatorMenu";
import { TemplateCreatorMenu } from "./TemplateCreatorMenu";
import { KitTypeMenuProps } from "./types";

type KitMenuProps = {
  mode: KitMenuTemplateMode;
};

export const KitMenu = ({ mode }: KitMenuProps) => {
  const groupSlug = useGroupSlug();
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { kit } = useKitData(groupUuid, kitUuid);

  if (!groupUuid || !groupSlug || !kit) {
    return null;
  }

  let KitTypeMenu: React.FC<KitTypeMenuProps> | null = null;

  switch (kit.type) {
    case "project_preset":
      KitTypeMenu = ProjectPresetMenu;
      break;
    case "project":
      KitTypeMenu = ProjectMenu;
      break;
    case "conversation":
      KitTypeMenu = ConversationMenu;
      break;
    case "interview":
      KitTypeMenu = InterviewMenu;
      break;
    case "repository":
      KitTypeMenu = RepositoryMenu;
      break;
    case "template":
      KitTypeMenu = TemplateCreatorMenu;
      break;
    case "expert":
      KitTypeMenu = ExpertCreatorMenu;
      break;
    case "skill":
      KitTypeMenu = SkillCreatorMenu;
      break;
    case "collection":
      KitTypeMenu = CollectionMenu;
      break;
    default:
      return null;
  }

  return (
    <KitTypeMenu
      key={kit.uuid}
      mode={mode}
      groupUuid={groupUuid}
      groupSlug={groupSlug}
      kit={kit}
    />
  );
};
